import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {StyleType} from '@catui/types';

const componentBaseName = 'form-userdata';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-form-userdata',
  templateUrl: './form-userdata.component.html',
  styleUrls: ['./form-userdata.component.scss'],
})
export class FormUserdataComponent implements OnInit {
  @HostBinding('class') classNames = defaultClassNames;
  @Output() downloadZip = new EventEmitter();
  @Output() downloadPackage = new EventEmitter();
  @Output() submitted = new EventEmitter();

  @Input() displayDownloadZip = false;
  @Input() isValid: boolean;
  @Input() isDirty: boolean;
  @Input() type = Type.Default;
  @Input() submitLabel = 'Save';
  @Input() inline = false;
  @Input() hideFooter = false;

  TypeInfo = Type;
  StyleType = StyleType;

  ngOnInit() {
  }

  submitForm($event) {
    this.submitted.emit($event);
  }
  onDownloadZip($event) {
    this.downloadZip.emit($event);
  }
}

export const Type = {
  Default: 'default',
  MultiPanel: 'multi-panel',
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/form-userdata/form-userdata.component.ts